import React from 'react';

import * as CreditActions from '../CreditActions';
import * as ActionConstants from '../../../utils/ActionConstants';
import * as CreditConstants from '../CreditConstants';
import CustomInput from '../../../common/components/CustomInput';
import CustomSelect from '../../../common/components/CustomSelect';
import * as Strings from '../../../utils/strings';
import { serializeForm, isValid } from '../creditUtils';

export default class CreditApplicationStep2 extends React.Component {
    next(e) {
        e.preventDefault();

        const form = serializeForm(this.refs);
        if (isValid(this.refs)) {
            CreditActions.goTo(CreditConstants.CREDIT_STEP3, { ...form });
        }
    }
    back = e => {
        e.preventDefault();
        CreditActions.goTo(CreditConstants.CREDIT_STEP1, {});
    };
    render() {
        // Address
        // City
        // Province
        // Postal Code
        // Contact Name
        // Contact Email

        // street: String
        // city: String
        // province: String
        // postalCode: String
        // contactName: String
        // contactEmail: String

        return (
            <div className="credit-application-step">
                <form onSubmit={this.next.bind(this)}>
                    <div className="form-container">
                        <div className="row">
                            <CustomInput
                                ref="street"
                                label={Strings.ADDRESS}
                                placeholder={Strings.ADDRESS_PLACEHOLDER}
                                required
                            />
                            <CustomInput
                                ref="city"
                                label={Strings.CITY}
                                placeholder={Strings.CITY_PLACEHOLDER}
                                required
                            />
                        </div>
                        <div className="row">
                            <CustomSelect
                                ref="province"
                                label={Strings.PROVINCE}
                                options={Strings.PROVINCES}
                                required
                            />
                            <CustomInput
                                ref="postalCode"
                                label="Postal Code"
                                placeholder="Z1X 2C3"
                                required
                            />
                        </div>
                        <div className="row">
                            <CustomInput
                                ref="contactName"
                                label={Strings.CREDIT_CONTACT_NAME}
                                placeholder={
                                    Strings.CREDIT_CONTACT_NAME_PLACEHOLDER
                                }
                                required
                            />
                            <CustomInput
                                ref="contactEmail"
                                type="email"
                                label={Strings.CREDIT_CONTACT_EMAIL}
                                placeholder={
                                    Strings.CREDIT_CONTACT_EMAIL_PLACEHOLDER
                                }
                                required
                            />
                        </div>
                    </div>
                    <button className="left back-button" onClick={this.back}>
                        Back
                    </button>
                    <button className="right green">
                        {' '}
                        {Strings.CREDIT_BTN_NEXT}
                    </button>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/credit/components/CreditApplicationStep2.jsx